import React from 'react'
import { View } from 'react-native'
import { useNavigation } from '@react-navigation/native'
import { Button, Text } from '@src/components/base'
import { StyleService, useStyleSheet } from '@src/style/service'
import { useNavigateToByosUpgrade } from '@screens/Marketplace/utils/hooks.ts'
import { useIsDexcomPartnerUser } from '@src/hooks/useIsDexcomPartnerUser'

interface UpsellCGMBannerProps {
  header?: any
  image: React.ReactElement
}

export const UpsellCGMBanner = ({ header, image }: UpsellCGMBannerProps) => {
  const styles = useStyleSheet(themedStyles)
  const navigation = useNavigation()

  const isDexcomUser = useIsDexcomPartnerUser()
  const {
    navigateToByosUpgrade,
    subscriptionEligibleForByosUpgrade,
    upgradableByosProducts,
  } = useNavigateToByosUpgrade()

  const textCopy = isDexcomUser
    ? // eslint-disable-next-line max-len
      'Track glucose in the Stelo app. Your Nutrisense nutritionist reviews your data to deliver personalized insights.'
    : // eslint-disable-next-line max-len
      "Purchase a CGM to track your body's glucose response to food and exercise. Get access to superior health insights."

  return (
    <>
      {header}
      <View style={styles.container}>
        {image}
        <View style={styles.content}>
          <Text style={styles.upsellCopy} type="regular">
            {textCopy}
          </Text>
          {!isDexcomUser && (
            <View style={styles.buttonsContainer}>
              {subscriptionEligibleForByosUpgrade && upgradableByosProducts.length > 0 && (
                <Button
                  onPress={() => navigateToByosUpgrade(false)}
                  accessibilityLabel="I already have a CGM"
                  type="transparent"
                  size="small"
                  style={styles.byosUpgradeButton}
                >
                  I already have a CGM
                </Button>
              )}
              <Button
                onPress={() => {
                  navigation.navigate('Subscriptions')
                }}
                accessibilityLabel="Upsell"
                type="primary"
                size="small"
              >
                Buy Now
              </Button>
            </View>
          )}
        </View>
      </View>
    </>
  )
}

const themedStyles = StyleService.create({
  container: {
    marginBottom: 8,
  },
  content: {
    position: 'absolute',
    bottom: '30%',
    left: 0,
    width: '100%',
    paddingHorizontal: 16,
  },
  upsellCopy: {
    paddingVertical: 8,
    textAlign: 'center',
  },
  buttonsContainer: {
    marginTop: 8,
    flexDirection: 'row',
    justifyContent: 'center',
  },
  alert: {
    marginHorizontal: 16,
    marginTop: 16,
    marginBottom: 16,
  },
  byosUpgradeButton: {
    marginRight: 16,
    borderWidth: 2,
    backgroundColor: 'theme.background',
    borderColor: 'theme.surface.base1',
  },
})
